import NewUserDetails from './NewUserDetails'

export default NewUserDetails
